import {memo} from 'react'

import {getOverviewHref} from '../../../../../routes'
import {BuildTypePageTabNamesEnum} from '../../../../../types'
import {objectToQuery} from '../../../../../utils/queryParams'
import Link from '../../../../common/Link/Link'
import RouterLinkWrapper from '../../../../common/RouterLinkWrapper/RouterLinkWrapper'

import type {Props} from './ChangesSinceLastSuccessfulBuild.types'

function ChangesSinceLastSuccessfulBuild(props: Props) {
  const {buildTypeId, branch, currentBuildNumber, lastSuccessfulBuildNumber} = props

  return (
    <RouterLinkWrapper>
      <Link
        href={`${getOverviewHref({
          buildTypeId,
        })}?${objectToQuery({
          branch,
          buildTypeTab: BuildTypePageTabNamesEnum.CHANGE_LOG,
          fromBuildNumber: currentBuildNumber,
          toBuildNumber: lastSuccessfulBuildNumber,
        })}`}
      >
        {'Changes since last successful build'}
      </Link>
    </RouterLinkWrapper>
  )
}

export default memo(ChangesSinceLastSuccessfulBuild)
